module.exports = __webpack_public_path__ + "static/media/faq-1800.21f0dfa6.jpg";